/**
 * Форматтеры для работы с клиентами
 */

import { getClientImportanceLabel } from '../model/constants';

/**
 * Форматирует важность клиента
 * @param value - значение важности
 * @returns отформатированное название
 */
export const formatClientImportance = (value: string): string => {
  return getClientImportanceLabel(value);
};

/**
 * Получает полное имя клиента
 * @param client - объект клиента
 * @returns полное имя клиента
 */
export const getClientFullName = (client: {
  first_name?: string | null;
  last_name?: string | null;
  patronymic_name?: string | null;
}): string => {
  const parts = [client?.first_name, client?.patronymic_name, client?.last_name].filter(Boolean);

  return parts.length > 0 ? parts.join(' ') : 'Без имени';
};
